var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import TextField from '@material-ui/core/TextField';
const inputComponent = (_a) => {
    var { inputRef } = _a, otherProps = __rest(_a, ["inputRef"]);
    return React.createElement("div", Object.assign({ ref: inputRef }, otherProps));
};
const JoinConversationInput = ({ children, selectProps, innerRef, innerProps }) => {
    return (React.createElement(TextField, Object.assign({ fullWidth: true, style: {
            height: '100%',
        }, InputProps: {
            inputComponent,
            inputProps: Object.assign({ className: selectProps.classes.input, inputRef: innerRef, children }, innerProps),
            disableUnderline: true,
        } }, selectProps.textFieldProps, { select: false, "data-qa": "searchAvaRoomInput" })));
};
export default JoinConversationInput;
